<template>
  <div class="home" id="home" style="margin: -15px;">
    <div id="drag">
      <div class="Yuan" @click="testShowBtn">
        <span></span>
        <span></span>
      </div>
      <div class="Yuan-title">
        <div class="YuanTitleDrag"></div>
        <div class="zTreeDiv">
          <ul id="WorkPlaneTree" class="ztree"></ul>
        </div>
      </div>
    </div>
    <iframe :key="url" :src="url" width="100%" height="100%"
      style="border: none;height: 92vh;border-radius: 7px;"></iframe>
  </div>
</template>

<script>
import {
  GetWorkPlaneTree2,
  GetDataFileList
} from "@/setAxios";
import interact from "interactjs";


export default {
  name: "viewModel",
  components: {},
  data() {
    return {
      count: 0,
      style2:
        "width: 500px; height: 400px; position: absolute; right: 20px; top: 14%; z-index: 1;display:none",
      value2D: "",
      testSshow: true,
      url: "",
      pid: -1,
      options: [],
      isdblclick: true,
      btnColor: "",
      show: true,
      timer: null,
      modelSelectIds: [],
      // optionsAdd: {},
      bool: true,
      list2D: null,
      changeSplit: false,
      modelId: "",
      dialogShareViewpoint: false,
      viewpointIds: "",
      shareTime: "",
      Viewpointshare: {
        dialogShareManage: false,
        viewpointData: [],
        dialogShareDetails: false,
        imageurl: "",
        sharedata: "",
        link: "",
        effectiveTime: "",
        title: "",
      },
      allDataFiles: [],
    };
  },
  methods: {
    // 判断类型
    judge(item) {
      if (item.wopl07 == 1) {
        return (item.iconSkin = "pIcon01");
      } else if (item.wopl07 == 2) {
        return (item.iconSkin = "pIcon02");
      } else if (item.wopl07 == 3) {
        return (item.iconSkin = "pIcon03");
      } else {
        return (item.iconSkin = "pIcon04");
      }
    },
    //初始化ztree
    init() {
      var _this = this;
      var setting = {
        view: {
          selectedMulti: false,
        },
        check: {
          enable: false,
        },
        data: {
          key: {
            name: "label",
          },
          simpleData: {
            enable: true,
            idKey: "ID",
            pIdKey: "ParentId",
          },
        },
        edit: {
          enable: true,
          showRemoveBtn: false,
          showRenameBtn: false,
          drag: {
            isMove: true,
            inner: true,
            prev: false,
            next: true,
          },
        },
        callback: {
          onClick: onclick,
        },
      };
      var objs = $.fn.zTree.init($("#WorkPlaneTree"), setting, this.options);
      if (objs != null) {
        if (localStorage.treeNid) {
          var currentNode = objs.getNodeByParam("ID", localStorage.treeNid);
          var name = currentNode.tId + "_a";
          $("#" + name).click();
        } else {
          $("#WorkPlaneTree_1_a").click();
        }
      }
      function onclick(event, treeId, treeNode) {
        localStorage.setItem("treeNid", treeNode.ID);
        _this.showModel(treeNode.ID);
      }
    },
    showModel(value) {
      var data = this.options.filter((v) => v.ID == value)[0];
      var item = null;
      if (data.wopl06 && data.wopl06.length > 0) {
        item = this.allDataFiles.filter((v) => v.prfl01 == data.wopl06)[0];
      }
      if (item) {
        let params = `fileId=${item.prfl01}&guid=${item.guid}&path=${item.prfl04}&xid=${item.prfl05}&name=${item.prfl02}`;
        params = Base64.encode(params);
        this.url = window.location.origin + `/#/viewFileModel?Code=${params}`;
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0)'
        });
        setTimeout(() => {
          loading.close();
        }, 2000);
      } else {
        this.$message({
          type: "warning",
          message: this.$t("工单任务.此节点未绑定数据或数据丢失"),
        });
      }
    },
    testShowBtn() {
      if ($(".Yuan-title").css("display") != "none") {
        $(".Yuan-title").css("display", "none");
      } else {
        $(".Yuan-title").css("display", "block");
      }
    },

    getData() {
      let params = {
        xid: localStorage.getItem("xid"),
        pid: this.pid,
      };
      GetWorkPlaneTree2(params).then((res) => {
        this.options = res.Data;
        this.options.forEach((item) => {
          this.judge(item);
        });
        this.init();
      });
    },
    GetDataFileList() {
      let params2 = {
        xid: localStorage.getItem("xid"),
        uid: localStorage.getItem("id"),
        gid: "null",
        type: 1,
        pageIndex: 1,
        pageSize: 99999,
      };
      GetDataFileList({ params: params2 }).then(res => {
        if (res.Data.list && res.Data.list.length > 0) {
          res.Data.list = res.Data.list.filter(w => w.isHide == 0)
          this.allDataFiles = res.Data.list;
        }
        this.getData();
      })
    },
  },
  created() {
    this.GetDataFileList();
    this.$store.state.isClickProject = true;
  },
  mounted() {
    document.oncontextmenu = function () {
      return false;
    };
    window.updateViewTime = this.updateViewTime;
    Fcis.Fc(".Yuan", "#drag");
    Fcis.Fc(".lll", "#div_viewpoint");
    Fcis.Fc(".lll", "#gg");
    Fcis.Fc(".lll", "#crashCheckDiv");

    interact(".Yuan-title").resizable({
      edges: { top: false, left: false, bottom: true, right: true },
      listeners: {
        move: function (event) {
          let { x, y } = event.target.dataset;

          x = (parseFloat(x) || 0) + event.deltaRect.left;
          y = (parseFloat(y) || 0) + event.deltaRect.top;

          Object.assign(event.target.style, {
            width: `${event.rect.width}px`,
            height: `${event.rect.height}px`,
            transform: `translate(${x}px, ${y}px)`,
          });

          Object.assign(event.target.dataset, { x, y });
        },
      },
    });
  },
};
</script>

<style lang="less" scoped>
/deep/ .view {
  padding: 0;
}

#MyViewerDiv {
  height: 100%;
  width: 100%;
  position: absolute;
  // float: left;
}

#My2DViewerDiv {
  height: 95%;
  width: 100%;
  position: absolute;
  // float: left;
}

.home {
  // overflow: auto;
  height: 98%;
  position: relative;
}

.body_viewpoint {
  overflow: hidden;
  height: 90%;
  overflow-y: auto;
}

.body_viewpoint .treeDemo_viewpoint {
  // background: rgba(255, 255, 255, 0.8);
  width: 100%;
  height: 80%;
  border: none;
  // overflow-y: auto;
  // overflow-x: hidden;
  margin-bottom: 15px;
}

.layer-background {
  background: rgba(255, 255, 255, 0.8) !important;
}

.liveBarCodeShow {
  z-index: 10;
  position: absolute;
  width: 410px;
  // background: #eee;
}

.search-input {
  width: 140px;
}

.back {
  background: #eee;
}

#middle1 {
  width: 0;
  height: 100%;
  position: absolute;
  top: 0;
  left: 50%;
  z-index: 10;
  border-left: 18px dashed transparent;
  margin-left: -9px;
  cursor: e-resize;
  display: none;
}

/deep/ .ztree li span.button.pIcon01_ico_open,
/deep/ .ztree li span.button.button.pIcon01_ico_close,
/deep/ .ztree li span.button.pIcon01_ico_docu {
  margin-right: 2px;
  background: url("../../assets/img/singleMode.png") no-repeat scroll 3px 1px transparent;
  vertical-align: top;
  background-size: 80%;
  vertical-align: middle;
}

/* 新增 */
#left1 {
  height: 100vh;
  width: 100%;
  overflow: hidden;
  z-index: 1;
}

.YuanTitleDrag {
  height: 20px;
  width: 100%;
  cursor: all-scroll;
}

.sdbcName {
  font-size: 20px;
  font-weight: 300;
  cursor: all-scroll;
}

.btnSearch {
  position: absolute;
  left: 0;
}

.pos-re-left4 {
  position: relative;
  left: 4px;
}

.clo1 {
  font-weight: 300;
  position: absolute;
  right: 0 !important;
  color: #c3c3c3;
  font-size: 16px;
}

.w-h-bg-cor {
  width: 265px;
  height: 40px;
  /* background-color: #fff; */
}

#vp-btn-mark {
  margin: 1px 0 0 26px;
  display: inline-block;
}

#vp-btn-save {
  display: inline-block;
}

.dis-none {
  display: none;
}

.rMenu {
  visibility: hidden;
}

.pos-fixed {
  position: fixed;
}

.filter_box {
  cursor: default;
  display: none;
}

.dis-bok {
  display: block;
}

.mar-top3 {
  margin-top: 3%;
}

.crashCheck_box {
  cursor: default;
}

.gray {
  opacity: 0;
}

.height40p {
  height: 40px;
}

.width100 {
  width: 100%;
}

#vp-searchtxt {
  padding-left: 20px;
}

.down {
  cursor: pointer;
  color: #409eff;
}
</style>